module.exports = __webpack_public_path__ + "media/retinus-pvp-demo-video1.b74b6bca.mp4";